<template>
  <div>
    <b-modal :id="idModal" size="lg" modal-class="custom-dialog" @close="close"
    hide-footer no-close-on-backdrop :title="title">
			<div>
        <p class="custom-details">De los envíos buscados, un total de <b>{{ deliveriesToSearch ? deliveriesToSearch.length : 0 }}</b> no arrojaron resultado</p>
        <div class="container-textarea">
          <b-form-textarea
          class="col-sm-11 custom-textarea"
          ref="dlvrestantes"
          rows="3"
          v-model="dlvrests"
          plaintext>
          </b-form-textarea>
          <b-button v-b-tooltip.hover :title="showCopied ? 'Copiado!' : 'Copiar' " id="copyButton" class="button-copy ml-1" variant="outline-primary" @click="copyToClipboard"><FeatherIcon icon="CopyIcon"></FeatherIcon></b-button>
        </div>
        <div class="custom-footer col-sm-11">
          <FeatherIcon class="custom-bold" icon="InfoIcon" size="50"></FeatherIcon>
          <p class="custom-info"> 
            Los envíos buscados deben estar en el estado <b class="custom-bold">'{{ tabName ? infoStatus[tabName].status : '' }}'</b> para obtener resultados. 
            {{ infoStatus[tabName].text }}
            Para más detalles, puedes usar la multibúsqueda en la barra de navegación para ver el estado actual de esos envíos no encontrados. 
          </p>
        </div>
			</div>
    </b-modal>
  </div>
</template>
<script>
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'



export default {
  props:{
    deliveriesToSearch: {
      type: Array,
      require: true,
      default: () => []
    },
    tabName : {
      type: String,
      required: true,
      default: ''
    }
  },
  data() {
    return {
      idModal: 'modalMissingResult',
      title: 'Envíos restantes',
      dlvrests: null,
      infoStatus: {
        label: {
          status: 'Creado',
          text: 'Si no se encuentran en ese estado o no existen en la plataforma, no se mostrarán.'
        },
        print: {
          status: 'Listo para despacho',
          text: 'Si no se encuentran en ese estado, en un manifiesto cerrado, o no existen en la plataforma, no se mostrarán.'
        }, 
        printed: {
          status: 'Listo para despacho-impreso o Manifiesto cerrado',
          text: 'Si no se encuentran en esos estados o no existen en la plataforma, no se mostrarán.'
        }, 
        observation: {
          status: 'Rechazado por courier',
          text: 'Si no se encuentran en ese estado o no existen en la plataforma, no se mostrarán.'
        }
      },
      showCopied: false
    }
  },
  methods: {
    copyToClipboard() {
      this.showCopied = true
      this.$refs.dlvrestantes.select()
      navigator.clipboard.writeText(this.$refs.dlvrestantes.value)
      setTimeout(() => { this.showCopied = false }, 1000)
    },
    close() {
      this.showCopied = false
      this.$bvModal.hide('modalMissingResult')
    }
  },
  watch: {
    deliveriesToSearch() {
      this.dlvrests = this.deliveriesToSearch ? this.deliveriesToSearch.join(', ') : null
    }
  }
}
</script>
<style>
.custom-footer {
  display: flex;
  align-items: center;
  background-color: #E6EFFA;
  border-radius: 0.5em;
  padding: 1em 0.5em 0.5em;
  margin-bottom: 1em;
  margin-top: 1em;
}
.custom-details {
  font-family: Montserrat;
  font-size: 1.1em;

}
.custom-info {
  line-height: normal;
  font-family: Montserrat;
  font-size: 0.7em;
  padding: 1em 1em 0em;
}
#list-ids{
  display: flex;
  align-items: center;
  margin: -1em
}
.custom-bold {
  color: #0169DE;
}
.button-copy {
  padding: 0.8em;
}
.container-textarea{
  display: flex;
  align-items: center;
}
.custom-textarea{
  border-radius: 0.5em;
  border-style: solid;
  border-color: #D8D6DE;
  border-width: 0.1em;
  padding: 1.2em 1.3em;
}
</style>